import { POPULATION_TYPE } from "@/common/models";
import { EntityCounter, InvEntityType, Subject } from "../data/model";
import employee_sender_handler from "./employee-sender";
import employee_receiver_handler from "./employee-receiver";
import organizations_handler from "./organization";
import external_contact_handler from "./external-contact";
import personal_address_handler from "./private-email";
import folders_handler from "./folders";
import events_handler from "./events";
import files_handler from "./files";
import employee_handler from "./employee";
import { TimeFrameOption } from "@/common/state/models";

// org, contact, private_address, : employees folder files events
// folder : employees(both) contacts orgs private files events
// employees, labels : all
export const get_entity_counters = async (
  subject: Subject,
  relative_time_frame: TimeFrameOption
): Promise<Record<InvEntityType, EntityCounter>> => {
  let res;
  if (
    [POPULATION_TYPE.EMPLOYEE, POPULATION_TYPE.LABEL].includes(subject.type)
  ) {
    res = await Promise.all(
      [
        employee_sender_handler,
        employee_receiver_handler,
        personal_address_handler,
        organizations_handler,
        external_contact_handler,
        folders_handler,
        files_handler,
        events_handler,
      ].map(({ get_summary }) => get_summary({ subject, relative_time_frame }))
    );
  } else if (subject.type === POPULATION_TYPE.FOLDER) {
    res = await Promise.all(
      [
        employee_handler,
        external_contact_handler,
        organizations_handler,
        personal_address_handler,
        files_handler,
        events_handler,
      ].map(({ get_summary }) => get_summary({ subject, relative_time_frame }))
    );
  } else {
    res = await Promise.all(
      [
        employee_sender_handler,
        folders_handler,
        files_handler,
        events_handler,
      ].map(({ get_summary }) => get_summary({ subject, relative_time_frame }))
    );
  }
  if (res.every((d) => d.success)) {
    return res.reduce((acc, item) => {
      if (item.success) {
        const { count, type, desc, relative_count } = item.value;
        acc[type] = { count, desc, relative_count };
      }
      return acc;
    }, {} as Record<InvEntityType, EntityCounter>);
  } else {
    return {} as Record<InvEntityType, EntityCounter>;
  }
};

export const show_modal = (subject: Subject, counter_type: InvEntityType) => {
  switch (counter_type) {
    case POPULATION_TYPE.EMPLOYEE:
      employee_handler.show_modal(subject);
      break;
    case "EMPLOYEE_SENDER":
      employee_sender_handler.show_modal(subject);
      break;
    case "EMPLOYEE_RECEIVER":
      employee_receiver_handler.show_modal(subject);
      break;
    case POPULATION_TYPE.ORGANIZATION:
      organizations_handler.show_modal(subject);
      break;
    case POPULATION_TYPE.CONTACT:
      external_contact_handler.show_modal(subject);
      break;
    case POPULATION_TYPE.PRIVATE_EMAIL:
      personal_address_handler.show_modal(subject);
      break;
    case POPULATION_TYPE.FOLDER:
      folders_handler.show_modal(subject);
      break;
    case POPULATION_TYPE.EVENT:
      events_handler.show_modal(subject);
      break;
    case POPULATION_TYPE.FILE:
      files_handler.show_modal(subject);
      break;
    default:
      break;
  }
};
